import React, { forwardRef } from 'react';
import clsx from 'clsx';
import * as RSeparator from '@radix-ui/react-separator';
import { separator as separatorClass } from './separator.module.css';
export const Separator = forwardRef(({ className, ...props }, forwardedRef) => (React.createElement(RSeparator.Root, { decorative: true, className: clsx(separatorClass, className), ref: forwardedRef, ...props })));
Separator.displayName = 'Separator';
